import React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaInput from "../../../../ui-kit/kuika-input/kuika-input";
import KuikaSvg from "../../../../ui-kit/kuika-svg/kuika-svg";
import KuikaSmallMediumText from "../../../../ui-kit/typography/SmallMediumText/SmallMediumText";

interface RoleManagementTopBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  onAddFolder: () => void;
  onAddRole: () => void;
}

export const RoleManagementTopBar: React.FC<RoleManagementTopBarProps> = ({
  search,
  onSearchChange,
  onAddFolder,
  onAddRole
}) => (
  <div className="role-management-top-bar">
    <div className="role-management-search-container">
      <KuikaInput
        placeholder="Search in roles..."
        leftIcon={<KuikaSvg name="search" width={16} height={16} />}
        rightIcon={
          search ? <KuikaSvg name="x" width={16} height={16} pointer onClick={() => onSearchChange("")} /> : undefined
        }
        value={search}
        onChange={(e) => onSearchChange((e.target as HTMLInputElement).value)}
      />
    </div>
    <KuikaButton type="tertiary" size="sm" onClick={onAddFolder}>
      <KuikaSvg name="folder-plus" type="sidebar-icons" width={16} height={16} />
      <KuikaSmallMediumText>ADD FOLDER</KuikaSmallMediumText>
    </KuikaButton>
    <KuikaButton type="secondary" size="sm" onClick={onAddRole}>
      <KuikaSvg name="key" width={16} height={16} />
      <KuikaSmallMediumText>ADD ROLE</KuikaSmallMediumText>
    </KuikaButton>
  </div>
);
